import Servicios from "@/views/Servicios.vue";

const servicios = {
  path: "/app/servicios",
  name: "servicios",
  component: Servicios,
};

export default servicios;
